import useAsync from 'Hooks/useAsync';
import { getBookingForBookingDetailedView } from 'Services/CustomGql/BookingEntityType';

export function useBookingDetailedView(bookingId: string) {
	const response = useAsync(() => getBookingForBookingDetailedView(bookingId), [bookingId]);
	return { response };
}
